import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'
import { get } from 'lodash'
import I18n from 'I18n'

ButtonDelete.propTypes = {
  constructorFunctions: PropTypes.object.isRequired,
  withinDropdown: PropTypes.bool,
  type: PropTypes.string.isRequired
}

export default function ButtonDelete({
  constructorFunctions,
  type,
  withinDropdown = false
}) {
  return (
    <Button
      icon='delete'
      className={
        withinDropdown ? 'btn-within-dropdown btn-delete' : 'btn-delete'
      }
      type='danger'
      onClick={e => {
        e.stopPropagation() // necessary to prevent the click event from bubbling up when use in a dropdown's table rown
        get(constructorFunctions, 'askDeleteSubPermit')(type)
      }}
    >
      {I18n.t(`pages.permits.actions.delete`)}
    </Button>
  )
}
